export function metricLabel(metric: "average" | "maximum") {
  return metric === "average" ? "Avg" : "Max";
}
